module.exports = __webpack_public_path__ + "img/Axel_Plug.7676d2cd.png";